import { SITE } from "@/config/site";

let initialised = false;

// Loads GA4 / Meta Pixel only when real IDs replace the placeholders in config/site.js
export function initAnalytics() {
  if (initialised) return;
  initialised = true;

  if (SITE.gaId && !SITE.gaId.includes("XXXX")) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${SITE.gaId}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", SITE.gaId);
  }

  if (SITE.metaPixelId && !SITE.metaPixelId.includes("XXXX")) {
    const n = (window.fbq = window.fbq || function () { n.queue.push(arguments); });
    n.queue = n.queue || [];
    n.loaded = true;
    n.version = "2.0";
    const t = document.createElement("script");
    t.async = true;
    t.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(t);
    window.fbq("init", SITE.metaPixelId);
    window.fbq("track", "PageView");
  }
}

// Conversion events: form_submit, whatsapp_click, phone_click, assessment_request, quote_request, service_enquiry
export function track(event, params = {}) {
  try {
    if (window.gtag) window.gtag("event", event, params);
    if (window.fbq) window.fbq("trackCustom", event, params);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch (e) { /* analytics must never break the app */ }
}
